import { Link } from "react-router-dom";
import BreadCrumbComp from "../components/BreadCrumbComp";
import PageSchema from "../components/PageSchema";
import classes from "./PrivacyPolicy.module.css";

export default function PrivacyPolicy() {
  return (
    <>
      <PageSchema
        type="WebPage"
        title="Privacy And Cookie Policy - How Prime Cloud Systems Protects Your Personal Data"
        description="At Prime Cloud Systems, your privacy matters. Learn how we securely collect, use, and protect customer information while shopping for IT hardware online."
        url="https://primecloudsystems.com/privacy-policy"
        breadcrumbs={[
          { name: "Home", url: "https://primecloudsystems.com/" },
          {
            name: "Privacy Policy",
            url: "https://primecloudsystems.com/privacy-policy",
          },
        ]}
      />

      <BreadCrumbComp
        currentPage="Privacy Policy"
        title="Privacy & Cookie Policy | Prime Cloud Systems"
        description="Explore Prime Cloud Systems’ Privacy & Cookie Policy to learn how we collect, use, and protect your data, ensure secure transactions, and responsibly manage cookies for a safe online experience."
      />

      <div className={`container ${classes.privacyPolicyContainer}`}>
        <p className={classes.paragraph}>
          <b>Who we are</b>: Our website address is:{" "}
          <Link to={"https://primecloudsystems.com/"}>
            https://primecloudsystems.com/
          </Link>
        </p>
        <h2 className={classes.subheading}>
          What personal data we collect and why we collect it
        </h2>
        <h2 className={classes.subheading}>Comments</h2>
        <p className={classes.paragraph}>
          When visitors leave comments on the site we collect the data shown in
          the comments form, and also the visitor’s IP address and browser user
          agent string to help spam detection.
        </p>
        <p className={classes.paragraph}>
          An anonymized string created from your email address (also called a
          hash) may be provided to the Gravatar service to see if you are using
          it. The Gravatar service privacy policy is available here:{" "}
          <Link to={"https://automattic.com/privacy/"}>
            https://automattic.com/privacy/
          </Link>
          . After approval of your comment, your profile picture is visible to
          the public in the context of your comment.
        </p>
        <h2 className={classes.subheading}>Media</h2>
        <p className={classes.paragraph}>
          If you upload images to the website, you should avoid uploading images
          with embedded location data (EXIF GPS) included. Visitors to the
          website can download and extract any location data from images on the
          website.
        </p>
        <h2 className={classes.subheading}>Cookies</h2>
        <p className={classes.paragraph}>
          If you leave a comment on our site you may opt-in to saving your name,
          email address and website in cookies. These are for your convenience
          so that you do not have to fill in your details again when you leave
          another comment. These cookies will last for one year.
        </p>
        <p className={classes.paragraph}>
          If you have an account and you log in to this site, we will set a
          temporary cookie to determine if your browser accepts cookies. This
          cookie contains no personal data and is discarded when you close your
          browser.
        </p>
        <p className={classes.paragraph}>
          When you log in, we will also set up several cookies to save your
          login information and your screen display choices. Login cookies last
          for two days, and screen options cookies last for a year. If you
          select “Remember Me”, your login will persist for two weeks. If you
          log out of your account, the login cookies will be removed.
        </p>
        <p className={classes.paragraph}>
          If you edit or publish an article, an additional cookie will be saved
          in your browser. This cookie includes no personal data and simply
          indicates the post ID of the article you just edited. It expires after
          1 day.
        </p>
        <h2 className={classes.subheading}>
          Embedded content from other websites
        </h2>
        <p className={classes.paragraph}>
          Articles on this site may include embedded content (e.g. videos,
          images, articles, etc.). Embedded content from other websites behaves
          in the exact same way as if the visitor has visited the other website.
        </p>
        <p className={classes.paragraph}>
          These websites may collect data about you, use cookies, embed
          additional third-party tracking, and monitor your interaction with
          that embedded content, including tracking your interaction with the
          embedded content if you have an account and are logged in to that
          website.
        </p>
        <h2 className={classes.subheading}>How long we retain your data</h2>
        <p className={classes.paragraph}>
          If you leave a comment, the comment and its metadata are retained
          indefinitely. This is so we can recognize and approve any follow-up
          comments automatically instead of holding them in a moderation queue.
        </p>{" "}
        <p className={classes.paragraph}>
          For users that register on our website (if any), we also store the
          personal information they provide in their user profile. All users can
          see, edit, or delete their personal information at any time (except
          they cannot change their username). Website administrators can also
          see and edit that information.
        </p>
        <h2 className={classes.subheading}>
          {" "}
          What rights you have over your data
        </h2>
        <p className={classes.paragraph}>
          If you have an account on this site, or have left comments, you can
          request to receive an exported file of the personal data we hold about
          you, including any data you have provided to us. You can also request
          that we erase any personal data we hold about you. This does not
          include any data we are obliged to keep for administrative, legal, or
          security purposes.
        </p>
        <h2 className={classes.subheading}> Where we send your data</h2>
        <p className={classes.paragraph}>
          Visitor comments may be checked through anautomated spam detection
          service.
        </p>
      </div>
    </>
  );
}
